import React, { useState } from "react";
import LoginForm from "./components/LoginForm";
import AdminDashboard from "./components/AdminDashboard";
import UserDashboard from "./components/UserDashboard";
import ResetPassword from "./components/ResetPassword";
import "./App.css";

function App() {
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [view, setView] = useState("login"); // "login" | "reset"

  // Om inloggad, visa dashboard direkt
  if (user) {
    return (
      <div className="app-wrapper">
        <h1>Webremote</h1>
        {user.role === "admin"
          ? <AdminDashboard user={user} onLogout={() => { setUser(null); setShowLogin(false); setView("login"); }} />
          : <UserDashboard user={user} onLogout={() => { setUser(null); setShowLogin(false); setView("login"); }} />}
      </div>
    );
  }

  // Splash: Pi-symbolen
  if (!showLogin && !user) {
    return (
      <div className="splash-center" onClick={() => setShowLogin(true)}>
        <span className="splash-pi">&#960;</span>
      </div>
    );
  }

  // Login/Reset-password
  return (
    <div className="app-wrapper">
      <h1 style={{ textAlign: "center" }}>Webremote</h1>
      <div className="login-form-centered">
        {view === "login" && (
          <LoginForm
            onLogin={(u) => {
              setUser(u);
              setView("login");
            }}
            onShowReset={() => setView("reset")}
          />
        )}
        {view === "reset" && (
          <ResetPassword onBack={() => setView("login")} />
        )}
      </div>
    </div>
  );
}

export default App;
